<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a><span class="small">DEDICATION</span></p>
<p class="dedication1">There is a real-life trader in Qolorha, whose name is Rufus Hulley, who took me to places of miracles and untold beauty. He must not be mistaken for John Dalton, the trader of <em>The Heart of Redness</em>, who is purely a fictional character. I am grateful to Rufus, and to Jeff Peires, whose research—wonderfully recorded in <em>The Dead Will Arise</em> and in a number of academic papers—informed the historical events in my fiction. As for the people of Qolorha, they will forgive me for reinventing their lives.</p>
<p class="dedication2">I wrote this novel in honor of new lives, among which I count my son Zukile, my daughter Zukiswa Zenzile Moroesi, and my daughter’s son, Wandile.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e742747a